export const file = {
  "uuid": "872ba9d2-5f5f-4f2d-bb61-dfe6f087bc4d",
  "file_name": "Audio File Name",
  "input_file": {
      "url": "https://www.learningcontainer.com/wp-content/uploads/2020/02/Kalimba.mp3?_=1",
      "path": "HBCL_DEV_FILE_STORAGE/audio.wav"
  },
  "created_by": "puneeth@deloitte.com",
  "archive_details": {
      "is_archive": false,
      "archived_date": null
  },
  "outputs": {
      "diarization": {
          "result": {
              "no_of_speaker": "",
              "speakers_timestamps": [
                  {
                      "sequence_number": 1,
                      "speaker_name": "Speaker_0",
                      "start_time": 0.0,
                      "end_time": 14.3,
                      "speech_duration": 14.3
                  },
                  {
                      "sequence_number": 2,
                      "speaker_name": "Speaker_1",
                      "start_time": 14.3,
                      "end_time": 23.9,
                      "speech_duration": 9.599999999999998
                  }
              ],
              "error": ""
          }
      },
      "speaker_identification": {
          "result": {
              "puneeth": [
                  {
                      "path": "",
                      "url": ""
                  },
                  {
                      "path": "",
                      "url": ""
                  }
              ],
              "parth": [
                  {
                      "path": "",
                      "url": ""
                  },
                  {
                      "path": "",
                      "url": ""
                  }
              ],
              "error": ""

          }
      },
      "transcript": {
          "result": [
              {
                  "sequence_number": 1,
                  "speaker_name": "Speaker_0",
                  "start_time": 0.0,
                  "end_time": 14.3,
                  "speech_duration": 14.3,
                  "text": " What is the entire process has different from the existing dubbing? I can see only the point 3 is point 2 is different that Sharon is doing apart from that the entire step is the same as dubbing only."
              },
              {
                  "sequence_number": 2,
                  "speaker_name": "Speaker_1",
                  "start_time": 14.3,
                  "end_time": 23.9,
                  "speech_duration": 9.599999999999998,
                  "text": " Actually, I should say it is lesser than what we are doing in Nubbing because there is not there steps got neglected like dealing with the video. OK."
              }
          ],
          "error": ""
      },
      "translation": {
          "french": {
              "result": [
                  {
                      "sequence_number": 1,
                      "speaker_name": "Speaker_0",
                      "start_time": 0.0,
                      "end_time": 14.3,
                      "speech_duration": 14.3,
                      "text": " What is the entire process has different from the existing dubbing? I can see only the point 3 is point 2 is different that Sharon is doing apart from that the entire step is the same as dubbing only."
                  },
                  {
                      "sequence_number": 2,
                      "speaker_name": "Speaker_1",
                      "start_time": 14.3,
                      "end_time": 23.9,
                      "speech_duration": 9.599999999999998,
                      "text": " Actually, I should say it is lesser than what we are doing in Nubbing because there is not there steps got neglected like dealing with the video. OK."
                  },
                  {
                    "sequence_number": 3,
                    "speaker_name": "Speaker_0",
                    "start_time": 0.0,
                    "end_time": 14.3,
                    "speech_duration": 14.3,
                    "text": " What is the entire process has different from the existing dubbing? I can see only the point 3 is point 2 is different that Sharon is doing apart from that the entire step is the same as dubbing only."
                },
                {
                    "sequence_number": 4,
                    "speaker_name": "Speaker_1",
                    "start_time": 14.3,
                    "end_time": 23.9,
                    "speech_duration": 9.599999999999998,
                    "text": " Actually, I should say it is lesser than what we are doing in Nubbing because there is not there steps got neglected like dealing with the video. OK."
                },
                {
                  "sequence_number": 1,
                  "speaker_name": "Speaker_0",
                  "start_time": 0.0,
                  "end_time": 14.3,
                  "speech_duration": 14.3,
                  "text": " What is the entire process has different from the existing dubbing? I can see only the point 3 is point 2 is different that Sharon is doing apart from that the entire step is the same as dubbing only."
              },
              {
                  "sequence_number": 2,
                  "speaker_name": "Speaker_1",
                  "start_time": 14.3,
                  "end_time": 23.9,
                  "speech_duration": 9.599999999999998,
                  "text": " Actually, I should say it is lesser than what we are doing in Nubbing because there is not there steps got neglected like dealing with the video. OK."
              }
              ],
              "error": ""
          },
          "hindi": {
              "result": [
                  {
                      "sequence_number": 1,
                      "speaker_name": "Speaker_0",
                      "start_time": 0.0,
                      "end_time": 14.3,
                      "speech_duration": 14.3,
                      "text": " En qué se diferencia todo el proceso del doblaje existente? Solo puedo ver que el punto 3 es diferente de lo que Sharon está haciendo, aparte de que todo el paso es igual que solo el doblaje."
                  },
                  {
                      "sequence_number": 2,
                      "speaker_name": "Speaker_1",
                      "start_time": 14.3,
                      "end_time": 23.9,
                      "speech_duration": 9.599999999999998,
                      "text": " En realidad, debo decir que es menos de lo que estamos haciendo en Nubbing porque no se descuidaron pasos como tratar el video. DE ACUERDO."
                  }
              ],
              "error": ""
          },
          "english": {
              "result": [
                  {
                      "sequence_number": 1,
                      "speaker_name": "Speaker_0",
                      "start_time": 0.0,
                      "end_time": 14.3,
                      "speech_duration": 14.3,
                      "text": " What is the entire process has different from the existing dubbing? I can see only the point 3 is point 2 is different that Sharon is doing apart from that the entire step is the same as dubbing only."
                  },
                  {
                      "sequence_number": 2,
                      "speaker_name": "Speaker_1",
                      "start_time": 14.3,
                      "end_time": 23.9,
                      "speech_duration": 9.599999999999998,
                      "text": " Actually, I should say it is lesser than what we are doing in Nubbing because there is not there steps got neglected like dealing with the video. OK."
                  }
              ],
              "error": ""
          },
          "german": {
              "result": [
                  {
                      "sequence_number": 1,
                      "speaker_name": "Speaker_0",
                      "start_time": 0.0,
                      "end_time": 14.3,
                      "speech_duration": 14.3,
                      "text": " En qué se diferencia todo el proceso del doblaje existente? Solo puedo ver que el punto 3 es diferente de lo que Sharon está haciendo, aparte de que todo el paso es igual que solo el doblaje."
                  },
                  {
                      "sequence_number": 2,
                      "speaker_name": "Speaker_1",
                      "start_time": 14.3,
                      "end_time": 23.9,
                      "speech_duration": 9.599999999999998,
                      "text": " En realidad, debo decir que es menos de lo que estamos haciendo en Nubbing porque no se descuidaron pasos como tratar el video. DE ACUERDO."
                  }
              ],
              "error": ""
          }
      },
      "cloned_audio": {
          "english": {
              "result": {
                  "path": "https://dp9grapvh7yga.cloudfront.net/HBCL_DEV_FILE_STORAGE/audio_english.wav",
                  "url": "HBCL_DEV_FILE_STORAGE/audio_english.wav"
              },
              "error": ""
          },
          "spanish": {
              "result": {
                  "path": "https://dp9grapvh7yga.cloudfront.net/HBCL_DEV_FILE_STORAGE/audio_spanish.wav",
                  "url": "HBCL_DEV_FILE_STORAGE/audio_spanish.wav"
              },
              "error": ""
          }
      }
  }
}
